import {
  Breakpoints,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight
} from '@ngw6/us-components';
import React from 'react';
import {
  StyledBlackContainer,
  StyledInformationOfferContainer,
  StyledOfferCardWrapper,
  StyledOfferMicroText,
  StyledOfferTypeLabelWrapper
} from './styled';
import { Offer } from '../../typing/offer';
import TrimModuleOfferType from '../trim-module-offer-type';

interface OfferDetailsCardProps {
  readonly offer?: Offer;
}

export const OfferDetailsCard: React.FC<OfferDetailsCardProps> = (
  props
): JSX.Element | null => {
  const {offer} = props;
  const dealType = offer?.dealOfferTypes.length ? offer?.dealOfferTypes[0] : undefined
  return (
    <StyledOfferCardWrapper className="offer-details_container">
      <StyledOfferTypeLabelWrapper className="offer-details_type-wrapper">
        <StyledBlackContainer>
          <TrimModuleOfferType offerType={dealType}/>
        </StyledBlackContainer>
      </StyledOfferTypeLabelWrapper> 
      <StyledInformationOfferContainer className="offer-details_deal-details">
        <StyledOfferMicroText>
          <TextCustom
            appearance={TextAppearance.headline200}
            tag={TextTag.h2}
            style={{
              [Breakpoints.default]: {
                fontWeight: TextWeight.bold,
                color: TextColor.primary,
                fontSize: TextSize.TextSize24,
                lineHeight: TextLineHeight.TextLineHeight28
              }
            }}
          >
            {offer?.offerTitle}
          </TextCustom>

          <TextCustom
            appearance={TextAppearance.headline200}
            tag={TextTag.p}
            style={{
              [Breakpoints.default]: {
                color: TextColor.primary,
                fontSize: TextSize.TextSize14,
                lineHeight: TextLineHeight.TextLineHeight20,
                fontWeight: TextWeight.regular
              }
            }}
          >
            {offer?.offerSubtitle}
          </TextCustom>

          {offer?.dealCopy && (
            <TextCustom
              appearance={TextAppearance.headline200}
              tag={TextTag.p}
              style={{
                [Breakpoints.default]: {
                  fontSize: TextSize.TextSize14,
                  lineHeight: TextLineHeight.TextLineHeight20,
                  fontWeight: TextWeight.regular,
                  color: TextColor.inherit
                }
              }}
            >
              {offer?.offerCopy}
            </TextCustom>
          )}
          {offer?.dealLegal && (
            <TextCustom
              appearance={TextAppearance.headline200}
              tag={TextTag.p}
              style={{
                [Breakpoints.default]: {
                  fontSize: TextSize.TextSize14,
                  lineHeight: TextLineHeight.TextLineHeight20,
                  fontWeight: TextWeight.regular,
                  color: TextColor.inherit
                }
              }}
            >
              {offer?.offerLegal}
            </TextCustom>
          )}
        </StyledOfferMicroText>
      </StyledInformationOfferContainer>
    </StyledOfferCardWrapper>
  );
};
